import { formatDate } from '@angular/common';

import { CustomFormatter } from '@messageformat/core';

import { isDate } from '@kros-sk/utils-fn/date';
import { isNumber } from '@kros-sk/shared/utils-fn/number';
import { isString } from '@kros-sk/utils-fn/string';

export function dateFormatter(): CustomFormatter {
  return (value: unknown, locale: string, format: string | null) => {
    let date: Date | null = null;

    if (isDate(value)) {
      date = value;
    } else if (isNumber(value)) {
      date = new Date(value);
    } else if (isString(value)) {
      date = new Date(value);
    }

    if (date == null || isNaN(date.getTime())) {
      throw new Error('fmtDate: Invalid date value', { cause: value });
    }

    if (!format) {
      format = 'dd.MM.yyyy';
    }

    return formatDate(date, format, locale);
  };
}
